import Markdown from 'markdown-to-jsx'
import Image from 'next/image'
import React from 'react'

import { Button, ButtonLink, type ButtonProps } from '@/legacy-src/components/ui/button'
import useIsAppWebView from '@/legacy-src/hooks/useIsAppWebView'
import { getTranslate } from '@/legacy-src/utilities/i18n'
import notifyMobileApp, { NotifyAppMessages } from '@/legacy-src/utilities/notifyMobileApp'

import Icon from '../icons/Icon'

const InfoItem = ({ id }) => {
  const { t } = getTranslate()

  return (
    <div className="mb-4 flex items-center text-base">
      <Icon icon="check-small" color="secondary" size="md" className="mr-3" />
      <Markdown>{t(`component.premiumContent.tests.info${id}`)}</Markdown>
    </div>
  )
}
type Props = {
  categoryUrl: string
}

const TestYourself: React.FC<Props> = ({ categoryUrl }) => {
  const { t } = getTranslate()
  const isWebview = useIsAppWebView()

  const btnProps: { size: ButtonProps['size']; className: string; children: React.ReactNode } = {
    size: 'medium',
    className: 'mt-4',
    children: t('component.premiumContent.tests.selfTests'),
  }

  return (
    <div className="flex flex-wrap items-center gap-8 rounded-xl bg-sand-400 p-5 tablet:flex-nowrap">
      <div className="flex-grow tablet:basis-1/2">
        <h3 className="!mt-0 mb-6 text-3xl">{t(`component.premiumContent.tests.title`)}</h3>

        <InfoItem id="1" />
        <InfoItem id="2" />
        <InfoItem id="3" />
        {isWebview ? (
          <Button onClick={() => notifyMobileApp(NotifyAppMessages.BACK_BUTTON_CLICK)} {...btnProps} />
        ) : (
          <ButtonLink href={categoryUrl} {...btnProps} />
        )}
      </div>
      <div className="flex flex-grow justify-center tablet:basis-1/2">
        <Image
          src={`/images/hedepyPlus/test-yourself.svg`}
          alt={t('component.premiumContent.tests.title')}
          width="438"
          height="282"
          sizes="438px"
          className="rounded-xl"
        />
      </div>
    </div>
  )
}

export default TestYourself
